export var DriveFilePublicPermissionApi;
(function (DriveFilePublicPermissionApi) {
    DriveFilePublicPermissionApi["PUBLIC_READ"] = "public_read";
    DriveFilePublicPermissionApi["PUBLIC_READ_LOGGED_IN"] = "public_read_logged_in";
    DriveFilePublicPermissionApi["PRIVATE"] = "private";
})(DriveFilePublicPermissionApi || (DriveFilePublicPermissionApi = {}));
export var DriveFilePermissionApi;
(function (DriveFilePermissionApi) {
    DriveFilePermissionApi["READ"] = "read";
    DriveFilePermissionApi["WRITE"] = "write";
    DriveFilePermissionApi["DELETE"] = "delete";
    DriveFilePermissionApi["SHARE_READ"] = "share_read";
})(DriveFilePermissionApi || (DriveFilePermissionApi = {}));
export var DriveFileTypeApi;
(function (DriveFileTypeApi) {
    DriveFileTypeApi["APPLICATION"] = "application";
    DriveFileTypeApi["AUDIO"] = "audio";
    DriveFileTypeApi["FONT"] = "font";
    DriveFileTypeApi["IMAGE"] = "image";
    DriveFileTypeApi["TEXT"] = "text";
    DriveFileTypeApi["VIDEO"] = "video";
    DriveFileTypeApi["MISC"] = "misc";
})(DriveFileTypeApi || (DriveFileTypeApi = {}));
export var DriveFileStorageSourceApi;
(function (DriveFileStorageSourceApi) {
    DriveFileStorageSourceApi["PROJECT_API"] = "project_api";
    DriveFileStorageSourceApi["PROJECT_GAF_API"] = "project_gaf_api";
    DriveFileStorageSourceApi["PROJECT_PVP_FILESTORAGE"] = "project_pvp_filestorage";
    DriveFileStorageSourceApi["PROJECT_PPP_FILESTORAGE"] = "project_ppp_filestorage";
    DriveFileStorageSourceApi["PROJECT_PPP_TEMP_FILESTORAGE"] = "project_ppp_temp_filestorage";
})(DriveFileStorageSourceApi || (DriveFileStorageSourceApi = {}));
export var FileExceptionCodesApi;
(function (FileExceptionCodesApi) {
    FileExceptionCodesApi["FILE_NOT_FOUND"] = "file_not_found";
    FileExceptionCodesApi["STORAGE_NOT_FOUND"] = "storage_not_found";
    FileExceptionCodesApi["FAILED_TO_RETRIEVE_FILE_FROM_STORAGE"] = "failed_to_retrieve_file_from_storage";
    FileExceptionCodesApi["NO_MATCHING_STORAGE_WRAPPER_FOUND"] = "no_matching_storage_wrapper_found";
    FileExceptionCodesApi["FAILED_TO_GENERATE_DOWNLOAD_URL"] = "failed_to_generate_download_url";
    FileExceptionCodesApi["FAILED_TO_UPDATE_FILE"] = "failed_to_update_file";
    FileExceptionCodesApi["FILE_PERMISSION_ALREADY_GIVEN"] = "file_permission_already_given";
    FileExceptionCodesApi["FILE_PERMISSION_NOT_FOUND"] = "file_permission_not_found";
    FileExceptionCodesApi["FILE_PERMISSION_ALREADY_REVOKED"] = "file_permission_already_revoked";
    FileExceptionCodesApi["CANNOT_REVOKE_OWNER_PERMISSION"] = "cannot_revoke_owner_permission";
    FileExceptionCodesApi["CANNOT_REVOKE_NON_READ_PERMISSION"] = "cannot_revoke_non_read_permission";
})(FileExceptionCodesApi || (FileExceptionCodesApi = {}));
export var DriveFileContextTypeApi;
(function (DriveFileContextTypeApi) {
    DriveFileContextTypeApi["USER"] = "user";
})(DriveFileContextTypeApi || (DriveFileContextTypeApi = {}));
export var DriveFileActionApi;
(function (DriveFileActionApi) {
    DriveFileActionApi["UPDATE"] = "update";
})(DriveFileActionApi || (DriveFileActionApi = {}));
export var DriveFileEntityContextTypeApi;
(function (DriveFileEntityContextTypeApi) {
    DriveFileEntityContextTypeApi["PROJECT"] = "project";
})(DriveFileEntityContextTypeApi || (DriveFileEntityContextTypeApi = {}));
